import { render, staticRenderFns } from "./ImageBank.vue?vue&type=template&id=c393a9a2&scoped=true&"
import script from "./ImageBank.vue?vue&type=script&lang=js&"
export * from "./ImageBank.vue?vue&type=script&lang=js&"
import style0 from "./ImageBank.vue?vue&type=style&index=0&id=c393a9a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c393a9a2",
  null
  
)

export default component.exports